export default __webpack_public_path__ + "static/media/reward.77b0981b.gif";